<template>
    <div class="asteroid1" :style="{ 'width': `${size}px` }" :class="{ 'threat': threat }">
        <svg version="1.1" class="asteroid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 340 284.2" style="enable-background:new 0 0 340 284.2;" xml:space="preserve">
            <g>
                <path class="st0" d="M73.9,29.3c3.8-3.1,7.7-6.2,12.3-7.8c4.7-1.6,9.7-1.4,14.6-1.2c20.2,0.7,40.5,1.4,60.7,2.2
                    c6.7,0.2,13.5,0.5,19.8-1.8c7.7-2.7,14.2-8.9,22.3-9.9c1.5-0.2,3.4-0.5,3.8-2s-3-1-1.8-0.1c33.4,7.9,66.9,15.7,100.3,23.4
                    c-1.3-1.3-2.6-2.5-3.8-3.8c5.7-2.4,12.4,1.8,15.2,7.3s2.8,12,3.2,18.2c1,15.9,5,31.7,11.7,46.2c1.6,3.5,3.4,7.2,3.4,11
                    c-0.1,4.9-3.2,9.2-6,13.3c-13.2,18.9-22.7,40.3-28,62.7c-2.1,8.8-3.6,17.9-7.2,26.1c-3.7,8.3-10.1,15.9-18.7,18.5
                    c-7.7,2.3-16,0.5-24,1.7c-20.7,3.1-32.8,24.8-50.9,35.2c-13.6,7.7-30.3,8.7-45.7,5.8c-15.4-2.9-29.9-9.4-44.2-15.8
                    c-5.5-2.5-11.2-5.1-15-9.7c-7-8.5-5.6-20.9-8.8-31.3c-3.9-12.6-14.3-22-24.2-30.8c-15.5-13.6-30.9-27.2-46.4-40.9
                    c-2.7-2.4-5.5-4.9-6.8-8.2c-1-2.5-1.1-5.3-1.2-8c-0.5-17.2-0.1-34.2,7.7-49.9c2.3-4.6,5.4-7.9,9.4-11.1c7.3-6,14.7-11.9,22-17.8
                    C56.1,43.7,65,36.5,73.9,29.3z"/>
                <path class="st1" d="M326.8,84.7c-3.2-10.2-5.2-20.7-5.9-31.3c-0.1-1.3-0.1-2.5-0.2-3.8c-4.1,0.3-8.3,1.2-12.1,2.7
                    c-9.4,3.6-17.5,10-25.5,16.3c-5,4-10,7.9-15,11.9c-1.5,7.2-3,14.4-4.5,21.5c-0.9,4.5-2,9.2-4.8,12.9c-6.7,8.7-19.9,7.9-30.8,6.2
                    c3.9,4-2.4,9.7-7.6,11.6c-16.1,5.8-32.2,11.6-48.3,17.4c-3.3,1.2-6.8,2.4-10.3,2.6c-9.5,0.4-17.5-6.6-24.4-13.2
                    c3.3-4.5,6.9-8.7,11-12.5c-14,1.2-28,2.4-42,3.6c-4.4,0.4-9,0.7-13.1-0.9c-4.1-1.6-7.6-5.8-6.9-10.1c-11.2,2.1-23.3-0.7-32.4-7.6
                    c-3.6-2.7-6.7-6-10.8-7.8c-9-4-19.1,1.6-27.8-2.4c-1.7-0.8-3.6-1.5-5.4-1.8c-1.6,9.6-1.6,19.5-1.3,29.5c0,0,0,0.1,0,0.1
                    c3.4,2.4,7.4,3.7,11.3,5.3c24,9.8,43.6,29.6,53.2,53.7c10.3-1.2,20.9,0.6,30.1,5.2c-2.6-4.6-3.8-10-3.3-15.2
                    c34-1.3,59.7,38.7,93.6,35.7c-7.6,3-12.5,11.6-11.2,19.6c10.6-4.6,22.1-7,33.6-7c-0.3-6.3-0.6-12.6-0.9-18.9c4,3.3,8,6.5,12,9.8
                    c9.7-7.7,9-24.9-1.2-31.9c17.2-5.7,34.1-12.1,50.9-19c4.8-2,12.4-2.7,13.3,2.5c0.8,4.5-5,7-9.6,7.8c6.8,4.1,16.1,2.5,22-2.8
                    c2.4-2.2,4.2-4.8,5.5-7.8c0.3-0.9,0.7-1.9,1.1-2.8c1.1-3.5,1.5-7.3,1.2-11c-1-12.3-8.9-23.8-7.6-36.1
                    C304,102.6,315.6,93.9,326.8,84.7z"/>
                <path class="st2" d="M36.7,104.4c4.2,1.9,7.5,5.3,11.2,8.1c9.4,7.1,21.8,10,33.4,7.9c-0.8,4.5,2.8,8.8,7.1,10.5
                    c4.3,1.7,9,1.3,13.5,0.9c14.5-1.2,28.9-2.4,43.4-3.7c-4.2,3.9-8,8.2-11.4,12.9c7.1,6.8,15.4,14,25.2,13.6c3.7-0.2,7.2-1.4,10.6-2.6
                    c16.6-6,33.2-11.9,49.9-17.9c5.4-1.9,11.9-7.8,7.9-11.9c11.2,1.7,24.8,2.6,31.8-6.4c2.9-3.8,4-8.6,4.9-13.3
                    c1.6-7.4,3.1-14.8,4.7-22.2c5.1-4.1,10.3-8.2,15.4-12.2c8.2-6.5,16.5-13.1,26.3-16.8c3.9-1.5,8-2.4,12.1-2.7
                    c-0.3-4.9-0.8-9.9-3-14.3c-2.8-5.7-9.6-10-15.4-7.5c1.3,1.3,2.6,2.6,3.9,3.9c-33.3-7.8-66.5-15.8-99.7-23.7
                    c-0.5,1.2-2.3,1.5-3.7,1.7c-8.2,1-14.7,7.4-22.5,10.2c-6.4,2.3-13.3,2.1-20,1.8c-20.5-0.7-40.9-1.5-61.4-2.2
                    c-5-0.2-10.1-0.3-14.8,1.3c-4.7,1.6-8.6,4.8-12.5,8c-9,7.4-18,14.9-27,22.3C39.2,55.9,31.7,62,24.3,68.1c-4,3.3-7.2,6.7-9.5,11.4
                    c-3.5,7.2-5.5,14.7-6.7,22.4C17.1,106,27.4,100.2,36.7,104.4z"/>
            </g>
            <path class="st1" d="M148.9,208.9c-4,1.7-8.5-0.5-12-3s-6.9-5.7-11.2-6.3c-4.3-0.6-9.3,3.2-8,7.3c0.6,1.6,1.9,2.8,3.3,3.9
                c4.8,3.9,9.9,8,16.1,8.7c6.2,0.7,13.2-3.9,12.8-10c-0.1-1.2-0.5-2.4-1.4-3.2"/>
            <path class="st1" d="M268.8,182.3c-4.8,5.2-9.2,10.7-13.1,16.6c-0.4,0.6-0.8,1.3-0.7,2c0.1,0.6,0.6,1.2,1.1,1.6
                c1.7,1.7,3.4,3.4,5.1,5.1c1.1,1.1,2.3,2.3,3.9,2.8c3.6,1.2,7.4-1.6,9.2-4.9c4.4-7.9,1.4-19.1-6.5-23.6"/>
            <path class="st0" d="M229.8,159.3c8.2,1.6,16.7,2.2,25.1,1.9c4.9-0.2,10.2-1,13.6-4.5c4.4-4.5,4-11.6,3.3-17.9
                c-0.1-0.8-0.2-1.6-0.6-2.2c-2.1-3.2-6.7,0.2-9.3,0.6c-3.1,0.5-6.2-0.3-9.4,0.2c-7,1.2-13.5,5.3-17.9,10.9
                C232.2,151.6,230.4,155.3,229.8,159.3z"/>
            <path class="st0" d="M69.3,161.3c2.9-3,6.7-6.3,10.7-5.1c4.1,1.2,6.1,6.7,10.4,7.1c2-3.4-1.7-7.3-5-9.5c-5.1-3.6-11.4-7.3-17.3-5.2
                c-3.8,3.7-1.9,11.2,3.1,12.7"/>
            <path class="st0" d="M176.2,177.8c-5.3,0-10.7-0.1-16-0.1c-0.9-2.3,2.1-4,4.4-4.7c1.5-0.4,3.1-0.8,4.6-1.2c2.6-0.7,5.3-1.4,7.8-0.5
                s4.4,4,3.1,6.3c-1.6,1.1-3.7,1.5-5.6,1.1"/>
            <path class="st0" d="M297.3,77c-1.6,0-3.2,0.1-4.8,0.1c-2.9,6.4-2.4,14.2,1.1,20.3c0.4-5,1.2-10.6,5.3-13.4c3.4-2.3,8-1.8,12.1-1.2
                c-2.8-3.5-6.6-6.2-10.8-7.8c-2.6-1-6.5-0.8-7.1,2"/>
            <path class="st1" d="M102.5,110.9c0.8,0.5,1.5,1,2.3,1.6c1.7-3.7,5.8-5.8,9.9-6.4c4-0.6,8.2-0.1,12.3-0.2c1.5,0,3.3-0.4,3.6-1.8
                c0.2-1-0.4-1.9-1.1-2.7c-7-8.5-17.1-14.4-28-16.3c-3.6,2.9-5.7,7.7-5.3,12.3c0.6,6.8,5.9,12.6,5.8,19.4"/>
            <path class="st1" d="M221.1,110.8c4.7,0.5,9.4,0.3,14-0.4c3.5-0.5,7.5-1.9,8.5-5.3c1.2-4.3-3.3-7.9-7.4-9.6
                c-3.5-1.4-7.4-2.3-10.9-1.1c-3.5,1.2-6.3,5.3-4.9,8.8c-5.2,0.8-10.2,3.1-14.2,6.6c4.9,0.7,9.8,0.8,14.7,0.2"/>
            <path class="st1" d="M272.2,38.6c-0.5,2.7-1.6,5.7-0.4,8.2c5.7-2.3,12.2-2.8,18.2-1.5c3.2,0.7,6.4,1.9,9.5,1.3
                c3.2-0.6,6.2-3.8,5-6.8c-0.2-0.5-3.8-1.1-4.4-1.3c-1.7-0.5-3.5-1.1-5.2-1.6c-3.2-1-6.4-2-9.6-3c-6.5-2.1-13-4.2-19.5-6.3
                c-2.9-1-6.3-2.8-9.4-3.1c-3.5-0.4-2.7,3.6-2.1,5.9c1.3,4.8,4.6,8.8,9.1,4.8c1.8-1.6,4.1-4.3,6.7-2.8
                C272.3,33.4,272.6,36.5,272.2,38.6z"/>
            <path class="st2" d="M77.8,169.6c0.7,0.7,1.5,1.5,2.5,1.7c0.8,0.2,1.6-0.1,2.4-0.3c4.2-1.2,8.4-2.4,12.6-3.6
                c-1.7-1.9-3.4-3.8-5.1-5.6c-1.5-1.7-3.1-3.3-5.1-4.3c-1.9-0.9-4.1-1.2-6.2-1.3c-3.1-0.3-8.6,0.1-8.6,4.5c0,1.7,1.8,3.1,2.9,4.2
                C74.7,166.4,76.3,168,77.8,169.6z"/>
            <path class="st2" d="M243.3,162.8c4.1,2.6,8.1,5.7,13,6.3c5.6,0.7,11-2.1,15.9-4.9c1.3-0.7,2.5-1.5,3.4-2.7c0.9-1.3,1.1-2.9,1.2-4.4
                c0.3-5.5-0.9-11.1-3.5-16c-0.5-1-1.7-2-2.5-1.3c1.4,4.4-1,9.3-4.6,12.1c-3.7,2.8-8.3,3.9-12.8,4.8c-3.3,0.6-6.5,1.2-9.8,1.6
                c-2.2,0.3-5.2,0.1-7.3,0.9C238.4,160.5,241.1,161.3,243.3,162.8z"/>
            <path class="st2" d="M160,178.4c1.3,1.2,3,1.7,4.7,2.3c5.1,1.7,11,3.3,15.7,0.6c1.2-1.3,0.5-3.6-1-4.6c-1.5-1-3.4-1.1-5.2-1.1
                c-5.5,0-11.3,0-16.3,2.4"/>
            <path class="st2" d="M309,90.5c2.7-0.1,6-1.7,5.8-4.4c-2.2,0-3.4-2.4-5-3.9c-3.2-3.1-8.9-2.3-12.1,0.7c-2.3,2.1-5.1,6.3-3.1,9.4
                c0.7,1,1.9,2,3.2,1.8c1.7-0.3,2.7-2.4,4.4-3.1C304.3,90.2,306.8,90.6,309,90.5z"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: 'Asteroid1',
    props: {
        relativeSize: Number,
        threat: Boolean,
    },
    computed: {
        size: function() {
            return this.relativeSize / 2;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/palette';

@keyframes asteroidRotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.asteroid1 {
    .st0{fill:$darkblue;}
    .st1{fill:$blue;}
    .st2{fill:$lightblue;}
    margin-top: 22%;

    .asteroid {
        animation: asteroidRotate 20s linear infinite;
    }

    &.threat {
        .st0{fill:$darkestorange;}
        .st1{fill:$darkorange;}
        .st2{fill:$orange;}
    }
}
</style>